import { plateFont, numFont } from '../../../utils/fonts';
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function VehicleCard({ vehicle, maintenanceId }) {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={0}
      data-testid="public-vehicle-card"
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Box
          sx={{
            width: '56px',
            height: '56px',
            backgroundColor: theme.colors.accent,
            borderRadius: theme.radius.lg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DirectionsCarIcon sx={{ fontSize: 32, color: 'white' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              ...plateFont,
              fontSize: '24px',
              fontWeight: '700',
              color: theme.colors.primary,
              letterSpacing: '1px',
            }}
          >
            {vehicle?.registration_number}
          </Typography>
          <Typography sx={{ color: theme.colors.textMuted, fontSize: '14px' }}>
            {vehicle?.manufacturer} {vehicle?.model} {vehicle?.year_model && `(${vehicle.year_model})`}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          marginTop: '12px',
          padding: '8px 12px',
          backgroundColor: theme.colors.borderLight,
          borderRadius: theme.radius.md,
          fontSize: '12px',
          color: theme.colors.textMuted,
        }}
      >
        {t('public_maintenance.maintenance_number')}:{' '}
        <Box component="span" sx={{ ...numFont, fontWeight: '600' }}>
          {maintenanceId}
        </Box>
      </Box>
    </Paper>
  );
}

export default VehicleCard;
